export default __webpack_public_path__ + "static/IBMPlexSans-LightItalic-Latin2-13aa346ec359eaa168e236254cd191b4.woff";